import type { INotificationParams } from '@picsart/miniapp-sdk-types';

import { getContext } from '@/context';
import { isProd } from '@/consts/configs';

const DEDUP_WINDOW_MS = 3000;
let lastNotification: { title: string; timestamp: number } | null = null;

const showNotification = (args: INotificationParams) => {
  if (isProd) return;

  const now = Date.now();
  const title = args.title || '';

  // Skip duplicate within dedup window
  if (
    lastNotification &&
    lastNotification.title === title &&
    now - lastNotification.timestamp < DEDUP_WINDOW_MS
  ) {
    return;
  }

  lastNotification = { title, timestamp: now };
  getContext().layout.notification.show(args);
};

export { showNotification };
